if (!customElements.get('megamenu-element')) {
  class MegamenuElement extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        items: '[data-image]',
        image: '[megamenu-image-element]',
        spinner: '.megamenu---loader',
        mediaLink: '[megamenu-media-link]',
        mediaText: '[megamenu-media-text]',
        mediaBadge: '[megamenu-media-badge]',
        mediaCard: '.megamenu-grid__media-card'
      };
      this.init();
    }

    init() {
      const items = this.querySelectorAll(this.selectors.items);
      const imageElement = this.querySelector(this.selectors.image);
      const spinner = this.querySelector(this.selectors.spinner);
      const mediaLink = this.querySelector(this.selectors.mediaLink);
      const mediaText = this.querySelector(this.selectors.mediaText);
      const mediaBadge = this.querySelector(this.selectors.mediaBadge);
      const mediaCard = this.querySelector(this.selectors.mediaCard);

      if (!items.length || !imageElement) return;

      items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          const newImageUrl = item.getAttribute('data-image');
          const newImageAlt = item.getAttribute('data-image-alt') || '';
          const newMediaText = item.getAttribute('data-media-text') || '';
          const newMediaLink = item.getAttribute('data-media-link') || '';
          const newMediaBadge = item.getAttribute('data-media-badge') || '';
          const isFallbackCard = item.getAttribute('data-media-fallback') === 'true';
          if (!newImageUrl) return;

          // Show spinner while loading
          if (spinner) spinner.classList.remove('hidden');

          // Preload image first
          const tempImage = new Image();
          tempImage.src = newImageUrl;

          tempImage.onload = () => {
            imageElement.src = newImageUrl;
            imageElement.alt = newImageAlt;

            if (mediaCard) {
              mediaCard.classList.toggle('is-fallback-card', isFallbackCard);
            }

            if (mediaBadge) {
              mediaBadge.textContent = newMediaBadge;
              mediaBadge.hidden = !isFallbackCard || !newMediaBadge;
            }

            if (mediaText) {
              mediaText.textContent = newMediaText;
              mediaText.hidden = !isFallbackCard || !newMediaText;
            }

            if (mediaLink) {
              if (newMediaLink) {
                mediaLink.setAttribute('href', newMediaLink);
              } else {
                mediaLink.removeAttribute('href');
              }
            }

            if (spinner) spinner.classList.add('hidden');
          };

          // Hide spinner if the image fails to load
          tempImage.onerror = () => {
            if (spinner) spinner.classList.add('hidden');
            console.warn(`Image failed to load: ${newImageUrl}`);
          };
        });
      });
    }
  }

  customElements.define('megamenu-element', MegamenuElement);
}

if (!customElements.get('main-megamenu')) {
  class MainMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        listButton: '[megamenu-hover-item]',
        listContainer: '[megamenu-hover-object]'
      };
      this.init();
    }

    init() {
      this.listButtons = this.querySelectorAll(this.selectors.listButton);
      this.listContainers = this.querySelectorAll(this.selectors.listContainer);

      // Set initial active button and container
      this.activeButton = this.querySelector(`${this.selectors.listButton}.active`) || this.listButtons[0];
      this.activeContainer = this.querySelector(`${this.selectors.listContainer}.active`) || this.getContainerByButton(this.activeButton);

      this.setActive(this.activeButton);

      this.listButtons.forEach(button => {
        button.addEventListener('mouseenter', () => this.handleMouseEnter(button));
      });
    }

    getContainerByButton(button) {
      const datasetId = button.dataset.id;
      return this.querySelector(`${this.selectors.listContainer}[data-id="${datasetId}"]`);
    }

    handleMouseEnter(button) {
      if (this.activeButton === button) return;

      this.clearActive(this.activeButton);
      this.clearActive(this.activeContainer);

      this.setActive(button);
    }

    clearActive(element) {
      if (element) element.classList.remove('active');
    }

    setActive(button) {
      const container = this.getContainerByButton(button);

      if (button) button.classList.add('active');
      if (container) container.classList.add('active');

      this.activeButton = button;
      this.activeContainer = container;
    }
  }

  customElements.define('main-megamenu', MainMegaMenu);
}
